import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/info-article',
    name: 'info-article',
    component: () => import(/* webpackChunkName: "info-article" */ '../views/InfoArticleView.vue')
  },
  {
    path: '/info-mp',
    name: 'info-mp',
    component: () => import(/* webpackChunkName: "info-mp" */ '../views/InfoMpView.vue')
  },
  {
    path: '/task-index',
    name: 'task-index',
    component: () => import(/* webpackChunkName: "task-index" */ '../views/TaskIndexView.vue')
  },
  {
    path: '/task-content',
    name: 'task-content',
    component: () => import(/* webpackChunkName: "task-content" */ '../views/TaskContentView.vue')
  },
  {
    path: '/worker-mp',
    name: 'worker-mp',
    component: () => import(/* webpackChunkName: "worker-mp" */ '../views/WorkerMpView.vue')
  },
  {
    path: '/worker-wx',
    name: 'worker-wx',
    component: () => import(/* webpackChunkName: "worker-wx" */ '../views/WorkerWxView.vue')
  },
  {
    path: '/docs',
    name: 'docs',
    // route level code-splitting
    // this generates a separate chunk (docs.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "docs" */ '../views/DocsView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
